
<template lang="pug">
.flex.items-center
  SelectStore.people-header__select.q-mx-sm(
    :storeCode="storeCode"
    :floorCode="floorCode"
    inverted
    @change="onChangeStore"
  )

  //- 店舗営業時間の表示
  .people-header__text.q-mx-sm(v-if="store") 開店 {{store.begin_time|time}} 〜 閉店 {{store.end_time|time}}

</template>

<script>
import SelectStore from 'components/SelectStore'

export default {
  components: {SelectStore},

  props: {
    storeCode: String,
    floorCode: String,
  },

  computed: {
    store() {
      return this.$store.state.stores.find(store =>
        store.store_code == this.storeCode &&
        store.floor_code == this.floorCode) || {}
    },
  },

  methods: {
    onChangeStore(storeCode, floorCode) {
      this.$store.commit('route', {params: {storeCode, floorCode}})
    },
  },
}
</script>

<style lang="sass">
.people-header__select
  box-shadow: none !important
  padding: 0 !important

.people-header__text
  font-size: 1rem
</style>
